import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import {
  IAPIRecentPaymentDetailsModel,
  IAPIRecentPaymentsActivityModel,
} from "../interfaces";
import { ContactReferenceModel } from "./ContactDetailPageModel";
import { PaymentMethodModel } from "./PaymentMethodModels";
import { SystemColor, SystemColorsModel } from "./SystemColorsModel";

export class RecentPaymentActivityModel {
  total: number;
  totalAmount: number;
  payments: RecentPaymentActivityDataModel[];
  constructor(data?: Partial<RecentPaymentActivityModel>) {
    this.total = data?.total || 0;
    this.totalAmount = data?.totalAmount || 0;
    this.payments =
      data?.payments?.map((p) => new RecentPaymentActivityDataModel(p)) || [];
  }

  static deserializeAPIModel(
    data: IAPIRecentPaymentsActivityModel
  ): RecentPaymentActivityModel {
    const mappedData: Partial<RecentPaymentActivityModel> = {
      total: data.total,
      totalAmount: data.totalAmount,
      payments:
        data.payments?.map((p) =>
          RecentPaymentActivityDataModel.deserializeAPIModel(p)
        ) || [],
    };
    return new RecentPaymentActivityModel(mappedData);
  }
}
export class RecentPaymentActivityDataModel {
  createdDate: Date;
  contact?: ContactReferenceModel;
  amount: number;
  success: boolean;
  isRefundTransaction: boolean;
  paymentMethod?: PaymentMethodModel;
  status: string;
  colors: SystemColor;
  constructor(data?: Partial<RecentPaymentActivityDataModel>) {
    this.createdDate = new Date(data?.createdDate || "");
    this.contact = new ContactReferenceModel(data?.contact);
    this.amount = data?.amount || 0;
    this.success = data?.success || false;
    this.isRefundTransaction = data?.isRefundTransaction || false;
    this.paymentMethod = new PaymentMethodModel(data?.paymentMethod);

    if (this.isRefundTransaction) {
      this.status = this.success ? "Refunded" : "Refund Failed";
      this.colors = this.success
        ? SystemColorsModel.ligthPurpleColors()
        : SystemColorsModel.lightRedColor();
    } else {
      this.status = this.success ? "Paid" : "Failed";
      this.colors = this.success
        ? SystemColorsModel.ligthGreenColors()
        : SystemColorsModel.lightRedColor();
    }
  }

  static deserializeAPIModel(
    data: IAPIRecentPaymentDetailsModel
  ): RecentPaymentActivityDataModel {
    const mappedData: Partial<RecentPaymentActivityDataModel> = {
      createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
      contact:
        data.contact && ContactReferenceModel.deserializeAPIModel(data.contact),
      amount: data.amount,
      success: data.success,
      isRefundTransaction: data.isRefundTransaction,
      paymentMethod:
        data.paymentMethod &&
        PaymentMethodModel.deserializeAPIModel(data.paymentMethod),
    };
    return new RecentPaymentActivityDataModel(mappedData);
  }
}
